import React, { useEffect, useState } from 'react';
import { Button, Col } from 'antd';
import ArrowLeft from '../../../assets/images/fishery_profile/icons/ArrowLeft.png';
import ArrowRight from '../../../assets/images/fishery_profile/icons/ArrowRight.png';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../../common/components/sliders/assets/css/sliders.css';
import { useGlobalState } from './GlobalState';
import axios from 'axios';
import moment from 'moment-timezone';
import { exotic_fishery } from '../../common/Utils';
import { toUTCDate } from '../../../utils/date';
import { emptyDatesObject } from '../../availability_calendar/AvailabilityCalendar';
import { notification } from '../../../utils/messaging';
import { useIsAnglerLoggedInQuery } from '../../user_profile/userProfileSlice';
import UserLoginForm from '../../common/UserLoginForm';
import MenuDrawer from '../../common/components/menu/MenuDrawer';

const HideLake1 = 'Suite Management';
const HideLake2 = 'The Fishing Lake';
export default function SelectLake({
  setMaxGuestPerAngler,
  fishery_id,
  scrollToRef,
  disabled = false,
}) {
  const [lakeInfo] = useGlobalState('lakeInfo');
  const [lakeDetails, setLakeDetails] = useGlobalState('lakeDetails');

  const [userSelectedLakeId, setUserSelectedLakeId] =
    useGlobalState('userSelectedLakeId');
  const [, setUserSelectedLakeName] = useGlobalState('userSelectedLakeName');
  const [, setDisabledDates] = useGlobalState('disabledDates');
  const [, setLimitedDates] = useGlobalState('limitedDates');
  const [, setBookingsLoading] = useGlobalState('bookingsLoading');
  const [, setBookingDates] = useGlobalState('bookingDates');
  const [userSelectedPakage, setUserSelectedPakage] =
    useGlobalState('userSelectedPakage');
  const selectedPackageId =
    lakeDetails?.custom_slot_days?.[userSelectedPakage - 1]?.id;

  const [userSelectedAnglers, setUserSelectedAnglers] = useGlobalState(
    'userSelectedAnglers'
  );
  const [userSelectedRods, setUserSelectedRods] =
    useGlobalState('userSelectedRods');
  const [, setAccommodation] = useGlobalState('accommodation');

  const [, setAvailableTime] = useGlobalState('availableTime');
  const [, setArrivalTime] = useGlobalState('arrivalTime');
  const [, setDepartureTime] = useGlobalState('departureTime');

  const [, setLakeType] = useGlobalState('lakeType');
  const [, setGuestAllowed] = useGlobalState('guestAllowed');
  const [, setIsLakeExclusive] = useGlobalState('isLakeExclusive');
  const [, setBookingOverlay] = useGlobalState('bookingOverlay');
  const [, setTicketAvailable] = useGlobalState('ticketsAvailable');
  const [, setHowToBook] = useGlobalState('howToBook');
  const [, setEstimatedPricing] = useGlobalState('estimatedPricing');
  const [, setUserSelectedSwims] = useGlobalState('userSelectedSwims');
  const [, setUserBookingData] = useGlobalState('userBookingData');
  const [, setUserSelectedDoubleSwim] = useGlobalState(
    'userSelectedDoubleSwim'
  );
  const [, setLoading] = useState('loading');
  const [, setMaxRod] = useGlobalState('maxRod');
  const [, setLakeExclusive] = useGlobalState('lakeExclusive');
  const [bookingType, setBookingType] = useGlobalState('bookingType');

  const [showSignInDrawer, setShowSignInDrawer] = useState(false);
  const { data: isLoggedIn } = useIsAnglerLoggedInQuery();

  // For Floor lake slider
  const responsive = {
    all: {
      breakpoint: { max: 10000, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const [carouselNeed, setCarouselNeed] = useState(false);

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { totalItems, slidesToShow },
    } = rest;

    if (totalItems > slidesToShow && totalItems !== slidesToShow) {
      setCarouselNeed(true);
    } else {
      setCarouselNeed(false);
    }

    return (
      carouselNeed && (
        <>
          <div className='carousel-button-group'>
            <Button
              className='carousel-btn carousel-prev'
              onClick={() => !disabled && previous()}
            >
              <img alt='Arrow Left' src={ArrowLeft} />
            </Button>
            <Button
              className='carousel-btn carousel-next'
              onClick={() => !disabled && next()}
            >
              <img alt='Arrow Right' src={ArrowRight} />
            </Button>
          </div>
        </>
      )
    );
  };

  const getBookingsInfo = (lake_id, lake_exclusive_only = false) => {
    setBookingsLoading(true);
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    };

    let payload_data = {
      anglers: userSelectedAnglers,
      guest: userSelectedRods,
      lake_id: lake_id,
      date: moment(new Date()).format('YYYY-MM-DD'),
      book_lake_exclusive: lake_exclusive_only,
      custom_slot_id: selectedPackageId,
      booking_type: bookingType,
    };

    axios
      .post('booking/lake/details', payload_data, axios_config)
      .then((res) => {
        if (res.status === 200) {
          const _result = res.data.result;
          setDisabledDates(_result.fully_booked_dates.map(toUTCDate));
          setLimitedDates(
            _result?.limited_availability_dates?.map((ld) => ({
              ...ld,
              date: toUTCDate(ld.date),
            })) || []
          );
          setLakeDetails(_result);
          setGuestAllowed(_result.guest_allowed);
          setIsLakeExclusive(_result?.lake_exclusive_enabled);
          setLakeType(_result.lake_type);
          setTicketAvailable(_result.swims_tickets_available);
          setMaxRod(_result.max_rod_per_angler);
          setHowToBook(_result.how_to_book);
          setMaxGuestPerAngler(_result.guest_limit_per_angler);

          if (lake_id && scrollToRef?.current) {
            scrollToRef.current.scrollIntoView({
              block: 'start',
              inline: 'nearest',
              smooth: true,
            });
          }
          setBookingsLoading(false);
        } else {
          notification.error({
            description: 'Error processing result',
          });
          setBookingsLoading(false);
          setUserSelectedLakeId(null);
          setLoading(false);
        }
      })
      .catch((err) => {
        setUserSelectedLakeId(null);
        if (err && err.response) {
          if (err.response.status === 500) {
            notification.error({
              description: 'Server Response failed. Please try again later',
            });
          } else if (err.response.status === 401) {
            notification.error({
              description:
                'Your action will not be saved. Please Login and try again!',
            });
          } else if (err.response.status === 400) {
            notification.error({
              description: err.response.data['detail'],
            });
          } else if (err.response.status === 422) {
            if (err.response.data['detail'] === 'Signature has expired') {
              notification.error({
                description:
                  'Login session has been expired. Please Login to continue!',
              });
            } else {
              notification.error({
                description:
                  "OOPS! Server didn't like the request. If this persists please contact support team",
              });
            }
          } else if (err.response.status === 423) {
            notification.error({
              description:
                'Sorry ! this booking slot has been booked by another user, Try different booking!',
            });
          }
        }
        setBookingsLoading(false);
        setLoading(false);
      });
  };

  const checkUserCanBookLake = (lakeId) => {
    const axios_config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      params: {
        lake_id: lakeId,
      },
    };

    axios
      .get('booking/user_can_book', axios_config)
      .then((res) => {
        const { can_book = false, detail = 'Something went wrong!' } =
          res?.data;
        if (res.status !== 200 || !can_book) {
          notification.error({
            description: detail,
          });
          setUserSelectedLakeId(null);
          setUserSelectedLakeName(null);
          setLakeDetails([]);
        }
      })
      .catch((err) => {
        notification.error({
          description: err?.response?.data?.['detail'],
        });
      });
  };

  const handleLakeChange = (e, lakeDetails) => {
    if (disabled) {
      return;
    }
    const { id, name: lakeName = '', lake_exclusive_only } = lakeDetails;
    if (userSelectedLakeId !== id) {
      checkUserCanBookLake(id);
      // Reset Form
      setAccommodation(false);
      setAvailableTime(null);
      setEstimatedPricing(null);
      // setUserSelectedSwims(null);
      setUserSelectedAnglers(1);
      setUserSelectedRods(0);
      setLakeExclusive(false);
      // setUserSelectedLakeId(null);
      setBookingDates([{ ...emptyDatesObject }]);
      setArrivalTime(null);
      setDepartureTime(null);
      setUserSelectedPakage(null);
      // setDateText(`${new Date()}reset`);
      setBookingType('');
    }
    setUserSelectedLakeId(id);
    setAccommodation(lakeDetails?.accommodation);
    setUserSelectedLakeName(lakeName);
    getBookingsInfo(id, lake_exclusive_only);
    setUserSelectedSwims([]);
    setUserSelectedDoubleSwim([]);
    setUserBookingData({});
    setBookingOverlay(false);
  };

  useEffect(() => {
    if (lakeInfo && lakeInfo.length === 1) {
      handleLakeChange('', lakeInfo[0]);
    }
  }, [lakeInfo]);
  const idsToRemove = [HideLake1, HideLake2];
  const filteredItems =
    fishery_id.toString() === exotic_fishery
      ? lakeInfo?.filter((item) => !idsToRemove.includes(item.name))
      : lakeInfo;

  return (
    <>
      <Carousel
        swipeable={true}
        responsive={responsive}
        infinite={true}
        customButtonGroup={<ButtonGroup />}
        arrows={false}
        itemAriaLabel={'lake'}
      >
        {lakeInfo
          ? filteredItems.map((lake, index) => {
              const showMemberOnly =
                !isLoggedIn && lake?.access_type?.access_type === 'Member only';
              return (
                <Col
                  key={index}
                  span={24}
                  className={`lake-selection ${
                    userSelectedLakeId === lake.id ? 'active' : ''
                  } ${showMemberOnly ? 'member-only' : ''}`}
                >
                  <img
                    alt={lake.name}
                    id={lake.id}
                    onClick={(e) =>
                      !showMemberOnly && handleLakeChange(e, lake)
                    }
                    className='br15 bookings-slider-image'
                    src={lake.image}
                  />
                  <span className='mg-top-10'>
                    <p className='booking-slider-meta md-title dark-swim-blue bold-content gSemiBold txt-center fs-20'>
                      {lake.name}
                    </p>
                  </span>
                  {showMemberOnly && (
                    <div className={'lake-selection__log-in-overlay'}>
                      <div
                        className={
                          'lake-selection__log-in-overlay__message gSemiBold'
                        }
                      >
                        <p className='mg-bottom-5'>Member-only Lake!</p>
                        <p className='mg-bottom-0'>
                          <Button
                            type='primary'
                            className='sb-blue-bg-600 hover:sb-blue-300 white h-fit gSemiBold fs-16 br8 border-0 pd-left-15 pd-right-15 mg-right-8'
                            onClick={() => setShowSignInDrawer(true)}
                          >
                            Log In
                          </Button>
                          to book this lake
                        </p>
                      </div>
                    </div>
                  )}
                </Col>
              );
            })
          : ''}
      </Carousel>
      <MenuDrawer
        isOpen={showSignInDrawer}
        setIsOpen={setShowSignInDrawer}
        showFooter
      >
        <UserLoginForm
          useMobileButtonStyle
          noReload
          onLogin={() => setShowSignInDrawer(false)}
        />
      </MenuDrawer>
    </>
  );
}
